import { render, staticRenderFns } from "./CustomerGallery.vue?vue&type=template&id=4597230a&"
import script from "./CustomerGallery.vue?vue&type=script&lang=js&"
export * from "./CustomerGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports